import { Card, CardContent, CardHeader, CardTitle } from "@devhop/ui";
import type { CfDashboardMatchBucket } from "../api/types";

type CommentMatchBreakdownProps = {
  data?: CfDashboardMatchBucket[];
  isLoading: boolean;
};

// system enum cf_match_result -> label ลาว (อนุญาตให้ map ได้)
const MATCH_LABELS: Record<string, string> = {
  order_created: "ສ້າງອໍເດີສຳເລັດ",
  no_active_session: "ບໍ່ມີ session ເປີດ",
  no_cf_code: "ບໍ່ມີລະຫັດ CF",
  unmatched_code: "ລະຫັດບໍ່ກົງ",
  out_of_stock: "ສິນຄ້າໝົດ",
  duplicate_order: "ສັ່ງຊ້ຳ",
  session_closed: "session ປິດແລ້ວ",
  check_order_reply: "ກວດສອບອໍເດີ",
  ignored: "ຂ້າມ",
  message_pending: "ລໍຖ້າຂໍ້ຄວາມຢືນຢັນ",
};

export function CommentMatchBreakdown({
  data,
  isLoading,
}: CommentMatchBreakdownProps) {
  const buckets = data ?? [];
  const total = buckets.reduce((s, b) => s + b.count, 0);
  const created =
    buckets.find((b) => b.matchResult === "order_created")?.count ?? 0;
  const successRate = total > 0 ? Math.round((created / total) * 100) : 0;

  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">
          ຜົນການກວດຄອມເມັນ ແລະ ຂໍ້ຄວາມ
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && !data ? (
          <div className="space-y-2 py-2">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="h-6 w-full animate-pulse rounded bg-muted" />
            ))}
          </div>
        ) : total === 0 ? (
          <div className="py-8 text-center text-muted-foreground text-sm">
            ຍັງບໍ່ມີຂໍ້ມູນ
          </div>
        ) : (
          <div className="space-y-3">
            <div className="flex items-baseline justify-between">
              <span className="text-muted-foreground text-sm">
                ອັດຕາສ້າງອໍເດີສຳເລັດ
              </span>
              <span className="font-bold text-emerald-600 text-lg tabular-nums">
                {successRate}%
              </span>
            </div>
            <div className="space-y-2">
              {buckets.map((b) => {
                const pct = total > 0 ? Math.round((b.count / total) * 100) : 0;
                return (
                  <div key={b.matchResult} className="flex items-center gap-3">
                    <span className="w-32 shrink-0 truncate text-sm">
                      {MATCH_LABELS[b.matchResult] ?? b.matchResult}
                    </span>
                    <div className="h-2 flex-1 overflow-hidden rounded-full bg-muted">
                      <div
                        className={`h-full rounded-full ${
                          b.matchResult === "order_created"
                            ? "bg-emerald-500"
                            : "bg-slate-400"
                        }`}
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                    <span className="w-10 shrink-0 text-end text-sm tabular-nums">
                      {b.count}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
